import { useEffect, useState } from "react";
import Nav from "./assets/components/Nav";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./assets/components/Pages/Home";
import Books from "./assets/components/Pages/Books";
import BookDetails from "./assets/components/Pages/BookDetails";
import Cart from "./assets/components/Pages/Cart";
import Footer from "./assets/components/Footer";

function App() {
  const [cartItems, setCartItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("library-cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("library-cart", JSON.stringify(cartItems));
  }, [cartItems]);

  function addToCart(book) {
    setCartItems((items) => {
      const existingBook = items.find((item) => item.id === book.id);
      if (existingBook) {
        return items.map((item) =>
          item.id === book.id ? { ...item, quantity: item.quantity + 1 } : item,
        );
      }
      return [...items, { ...book, quantity: 1 }];
    });
  }

  function removeFromCart(bookId) {
    setCartItems((items) => items.filter((item) => item.id !== bookId));
  }

  function updateCartQuantity(bookId, change) {
    setCartItems((items) =>
      items
        .map((item) =>
          item.id === bookId
            ? { ...item, quantity: item.quantity + change }
            : item,
        )
        .filter((item) => item.quantity > 0),
    );
  }

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <Router>
      <div className="App">
        <Nav cartCount={cartCount} />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/books" exact component={Books} />
          <Route
            path="/books/:id"
            render={() => <BookDetails onAddToCart={addToCart} />}
          />
          <Route
            path="/cart"
            render={() => (
              <Cart
                cartItems={cartItems}
                onRemoveFromCart={removeFromCart}
                onUpdateQuantity={updateCartQuantity}
              />
            )}
          />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
